var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.consultaContenedores")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.secuencia,
                    expression: "!secuencia"
                  }
                ],
                staticClass: "btn-info btn--bigger",
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("message.buscar")))])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.puedeEditar && _vm.procesosConsultados.length > 0,
                    expression: "puedeEditar && procesosConsultados.length > 0"
                  }
                ],
                staticClass: "btn-info btn--text",
                on: { click: _vm.editarPropiedades }
              },
              [
                _c("i", { staticClass: "fa fa-edit" }),
                _vm._v(" "),
                _c("span", [_vm._v("Editar")])
              ]
            ),
            _vm._v(" "),
            _vm.procesosConsultados.length > 0
              ? _c(
                  "button",
                  {
                    staticClass: "btn-secondary btn--text",
                    on: { click: _vm.descargarTodos }
                  },
                  [
                    _c("i", { staticClass: "fa fa-download" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("message.descargarTodo")))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.procesosConsultados.length > 0
              ? _c(
                  "button",
                  {
                    staticClass: "btn-success btn--text",
                    on: { click: _vm.copiarLinks }
                  },
                  [
                    _c("i", { staticClass: "fa fa-link" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.copiarLinks")))])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.propiedadConsultada !== null,
                    expression: "propiedadConsultada !== null"
                  }
                ],
                staticClass: "btn-info btn--text",
                attrs: { type: "button" },
                on: { click: _vm.enviarCorreos }
              },
              [
                _c("i", { staticClass: "fa fa-envelope" }),
                _c("span", [_vm._v(_vm._s(_vm.$t("message.enviarEir")))])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.propiedadConsultada !== null,
                    expression: "propiedadConsultada !== null"
                  }
                ],
                staticClass: "btn-primary btn--text",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.verLogs("C")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file" }),
                _c("span", [_vm._v("Logs Caja")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.propiedadConsultada !== null &&
                      _vm.propiedadConsultada.is_maquina === "S",
                    expression:
                      "\n          propiedadConsultada !== null &&\n          propiedadConsultada.is_maquina === 'S'\n        "
                  }
                ],
                staticClass: "btn-primary btn--text",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.verLogs("M")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file" }),
                _c("span", [_vm._v("Logs Máquina")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.secuencia
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row mb-0" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.patios.length > 0,
                        expression: "patios.length > 0"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-3"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field select2-field--stretch" },
                        [
                          _c("v-select", {
                            attrs: {
                              options: _vm.patios,
                              label: "name",
                              id: "patios"
                            },
                            on: { input: _vm.inputPatio },
                            model: {
                              value: _vm.selectedPatio,
                              callback: function($$v) {
                                _vm.selectedPatio = $$v
                              },
                              expression: "selectedPatio"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "patios" } }, [
                            _vm._v("Yard")
                          ])
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field select2-field--stretch" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.contenedoresFiltrados,
                            label: "nombre",
                            id: "contenedores"
                          },
                          on: { input: _vm.consultar },
                          model: {
                            value: _vm.form.selectedContenedor,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "selectedContenedor", $$v)
                            },
                            expression: "form.selectedContenedor"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "contenedores" } }, [
                          _vm._v(_vm._s(_vm.$t("message.contenedor")))
                        ]),
                        _vm._v(" "),
                        _vm.errores.selectedContenedor
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.selectedContenedor[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.propiedadConsultada !== null &&
                _vm.propiedadConsultada.customer !== null &&
                _vm.propiedadConsultada.customer !== undefined
                  ? _c("div", { staticClass: "col-xs-12 col-md-9" }, [
                      _c("p", [
                        _c("label", { staticClass: "big-label" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("message.patio")) + ":")
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.propiedadConsultada.yard !== null
                                  ? _vm.propiedadConsultada.yard.name
                                  : ""
                              ) +
                              "\n              [" +
                              _vm._s(_vm.propiedadConsultada.yard_code) +
                              "]"
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "big-label" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("message.cliente")) + ":")
                          ]),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.propiedadConsultada.customer !== null &&
                                  _vm.propiedadConsultada.customer !== undefined
                                  ? _vm.propiedadConsultada.customer.name
                                  : ""
                              ) +
                              "\n              [" +
                              _vm._s(_vm.propiedadConsultada.customer_code) +
                              "]"
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "big-label" }, [
                          _c("strong", [_vm._v("Usuario creador:")]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.propiedadConsultada.cod_usuario)
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.propiedadConsultada !== null
        ? _c("div", { staticClass: "card mt-3" }, [
            _c("div", { staticClass: "card__title" }, [
              _c("h5", [_vm._v(_vm._s(_vm.propiedadConsultada.number))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-8" }, [
                  _c("h5", [
                    _vm._v(_vm._s(_vm.$t("message.informacionContenedor")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v(_vm._s(_vm.$t("message.eirCaja")))]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.eirMaquina")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.conductor")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.fechaIngreso")))
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v(_vm._s(_vm.$t("message.placa")))]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.observacionRep")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.observacionRepM")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.conductorOut")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.fechaSalida")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.placaOut")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.eirCajaOut")))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.propiedadConsultada.eir_in !== null,
                                    expression:
                                      "propiedadConsultada.eir_in !== null"
                                  }
                                ],
                                staticClass: "btn--outline btn-info",
                                on: { click: _vm.imprimirEir }
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.propiedadConsultada.eir_in) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.propiedadConsultada.eir_maquina_in !==
                                      null,
                                    expression:
                                      "propiedadConsultada.eir_maquina_in !== null"
                                  }
                                ],
                                staticClass: "btn--outline btn-secondary",
                                on: { click: _vm.imprimirEirMaquina }
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.propiedadConsultada.eir_maquina_in
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.propiedadConsultada.trucking_in))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.propiedadConsultada.gate_in_date))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.propiedadConsultada.layout))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.propiedadConsultada
                                    .kim_observacion_reparacion
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.propiedadConsultada
                                    .kim_observacion_reparacion_m
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.propiedadConsultada.trucking_out))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.propiedadConsultada.gate_out_date)
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.propiedadConsultada.segmento))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.propiedadConsultada.eir_out !== null,
                                    expression:
                                      "propiedadConsultada.eir_out !== null"
                                  }
                                ],
                                staticClass: "btn--outline btn-success",
                                on: { click: _vm.imprimirEirOut }
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.propiedadConsultada.eir_out) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("message.observaciones")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v(_vm._s(_vm.$t("message.tipo")))]),
                          _vm._v(" "),
                          _c("th", [_vm._v(_vm._s(_vm.$t("message.usuario")))]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.observacion")))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(
                            _vm.propiedadConsultada.observaciones,
                            function(observacion, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [_vm._v(_vm._s(observacion.modulo))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(observacion.nombre_usuario))
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(observacion.observacion))
                                ])
                              ])
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.propiedadConsultada.observaciones !==
                                      undefined &&
                                    _vm.propiedadConsultada.observaciones !==
                                      null &&
                                    _vm.propiedadConsultada.observaciones
                                      .length === 0,
                                  expression:
                                    "\n                  propiedadConsultada.observaciones !== undefined &&\n                  propiedadConsultada.observaciones !== null &&\n                  propiedadConsultada.observaciones.length === 0\n                "
                                }
                              ]
                            },
                            [
                              _c("td", { attrs: { colspan: "3" } }, [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.$t("message.sinDatos")))
                                ])
                              ])
                            ]
                          )
                        ],
                        2
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3 col-xs-12" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", { staticClass: "table--centered" }, [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.firmaConductor")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("message.firmaInspectorCaja"))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("message.firmaInspectorMaquina"))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.firmaSupEstCaja")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.firmaSupEstMaq")))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [
                            _vm.propiedadConsultada.firma_conductor
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada.firma_conductor,
                                    alt: "firma_conductor",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_conductor
                                        },
                                        _vm.$t("message.firmaConductor")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_conductor"
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.propiedadConsultada.firma_inspector_caja
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_inspector_caja,
                                    alt: "firma_inspector_caja",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_inspector_caja
                                        },
                                        _vm.$t("message.firmaInspectorCaja")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_inspector_caja"
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.propiedadConsultada.firma_inspector_maquina
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_inspector_maquina,
                                    alt: "firma_inspector_maquina",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_inspector_maquina
                                        },
                                        _vm.$t("message.firmaInspectorMaquina")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_inspector_maquina"
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.propiedadConsultada.firma_supervisor_est
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_supervisor_est,
                                    alt: "firma_supervisor_est",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_supervisor_est
                                        },
                                        _vm.$t("message.firmaSupEstCaja")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_supervisor_est"
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.propiedadConsultada.firma_supervisor_est_maq
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_supervisor_est_maq,
                                    alt: "firma_supervisor_est_maq",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_supervisor_est_maq
                                        },
                                        _vm.$t("message.firmaSupEstMaq")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_supervisor_est_maq"
                                  }
                                })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.firmaSupRepCaja")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.firmaSupRepMaq")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.firmaInspOut")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.firmaCondOut")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("message.firmaSupSal")))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [
                            _vm.propiedadConsultada.firma_supervisor_rep_caja
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_supervisor_rep_caja,
                                    alt: "firma_supervisor_rep_caja",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_supervisor_rep_caja
                                        },
                                        _vm.$t("message.firmaSupRepCaja")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_supervisor_rep_caja"
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.propiedadConsultada.firma_supervisor_rep_maq
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_supervisor_rep_maq,
                                    alt: "firma_supervisor_rep_maq",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_supervisor_rep_maq
                                        },
                                        _vm.$t("message.firmaSupRepMaq")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_supervisor_rep_maq"
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.propiedadConsultada.firma_inspector_out
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_inspector_out,
                                    alt: "firma_inspector_out",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_inspector_out
                                        },
                                        _vm.$t("message.firmaInspOut")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_inspector_out"
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.propiedadConsultada.firma_conductor_out
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_conductor_out,
                                    alt: "firma_conductor_out",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_conductor_out
                                        },
                                        _vm.$t("message.firmaCondOut")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_conductor_out"
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.propiedadConsultada.firma_supervisor_sal
                              ? _c("img", {
                                  staticClass: "img",
                                  attrs: {
                                    src:
                                      _vm.propiedadConsultada
                                        .firma_supervisor_sal,
                                    alt: "firma_supervisor_sal",
                                    width: "150px",
                                    height: "100px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.verImagen(
                                        {
                                          url:
                                            _vm.propiedadConsultada
                                              .firma_supervisor_sal
                                        },
                                        _vm.$t("message.firmaSupSal")
                                      )
                                    }
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    width: "150px",
                                    height: "100px",
                                    src: _vm.pathSinImagen,
                                    alt: "firma_supervisor_sal"
                                  }
                                })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-12" }, [
                  _c("h5", [
                    _vm._v(_vm._s(_vm.$t("message.observacionesRep")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.propiedadConsultada.procesosReparacion, function(
                      proceso,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index, staticClass: "col-xs-12 col-md-6" },
                        [
                          proceso.imagenes !== undefined &&
                          proceso.imagenes !== null &&
                          proceso.imagenes.length > 0
                            ? _c("item-grupo-contenedor", {
                                attrs: {
                                  imagenes: proceso.imagenes,
                                  errorText: _vm.errorText,
                                  usuarioText: _vm.userText,
                                  copyLinks: _vm.copyLinks,
                                  downloadGroup: _vm.downloadGroup,
                                  title: proceso.grupo
                                },
                                on: { verImagen: _vm.verImagen }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("h5", [
                    _vm._v(_vm._s(_vm.$t("message.observacionSalida")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v(_vm._s(_vm.$t("message.usuario")))]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.observacion")))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.propiedadConsultada.kim_usu_obs_out)
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.propiedadConsultada.kim_observacion_out
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c("h5", [_vm._v("Amounts")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.propiedadConsultada.amount_m
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.propiedadConsultada.amount_b
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.moneyFormat(
                                    _vm.propiedadConsultada.valor_maquina
                                  )
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.propiedadConsultada.valor_caja
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              !(
                _vm.secuencia !== "" &&
                _vm.secuencia !== null &&
                _vm.secuencia !== undefined
              )
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12" },
                      [
                        _c("h5", [_vm._v("Estado del contenedor")]),
                        _vm._v(" "),
                        _c("table-bar", {
                          attrs: {
                            rows: [
                              _vm.propiedadConsultada.garita_finalizada === "S",
                              ((_vm.propiedadConsultada.is_caja === "S" &&
                                _vm.propiedadConsultada.inspection_b === "S") ||
                                _vm.propiedadConsultada.is_caja !== "S") &&
                                ((_vm.propiedadConsultada.is_maquina === "S" &&
                                  _vm.propiedadConsultada.inspection_m ===
                                    "S") ||
                                  _vm.propiedadConsultada.is_maquina !== "S") &&
                                !(
                                  _vm.propiedadConsultada.is_caja === "N" &&
                                  _vm.propiedadConsultada.is_maquina === "N"
                                ),
                              ((_vm.propiedadConsultada.is_caja === "S" &&
                                _vm.propiedadConsultada.estimado_b === "S") ||
                                _vm.propiedadConsultada.is_caja !== "S") &&
                                ((_vm.propiedadConsultada.is_maquina === "S" &&
                                  _vm.propiedadConsultada.estimado_m === "S") ||
                                  _vm.propiedadConsultada.is_maquina !== "S") &&
                                !(
                                  _vm.propiedadConsultada.is_caja === "N" &&
                                  _vm.propiedadConsultada.is_maquina === "N"
                                ),
                              _vm.propiedadConsultada.is_caja === "S" &&
                                _vm.propiedadConsultada.aprobado_b === "S" &&
                                (_vm.propiedadConsultada.is_maquina === "N" ||
                                  (_vm.propiedadConsultada.is_maquina === "S" &&
                                    _vm.propiedadConsultada.aprobado_m ===
                                      "S")),
                              ((_vm.propiedadConsultada.is_caja === "S" &&
                                _vm.propiedadConsultada.repaired === "S") ||
                                _vm.propiedadConsultada.is_caja !== "S") &&
                                ((_vm.propiedadConsultada.is_maquina === "S" &&
                                  _vm.propiedadConsultada.repaired_m === "S") ||
                                  _vm.propiedadConsultada.is_maquina !== "S") &&
                                !(
                                  _vm.propiedadConsultada.is_caja === "N" &&
                                  _vm.propiedadConsultada.is_maquina === "N"
                                ),
                              _vm.propiedadConsultada.kim_salida === "S" ||
                                _vm.propiedadConsultada.status === "T"
                            ]
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "tabs",
        { on: { changed: _vm.tabChanged } },
        [
          _c(
            "tab",
            { attrs: { id: "IN", "is-disabled": !_vm.permiteEs, name: "IN" } },
            [
              _vm.form.modulo === "IN" && _vm.propiedadConsultada != null
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "table-responsive" }, [
                        _c("table", [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("message.locacion")) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("message.observacion")) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Tipo")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Interno")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(
                                _vm.propiedadConsultada
                                  .observaciones_localizacion_in,
                                function(row, index) {
                                  return _c("tr", { key: index }, [
                                    _c("td", [
                                      _vm._v(_vm._s(row.localizacion))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(row.observacion))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          row.tipo === "C" ? "Caja" : "Máquina"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(row.interno))])
                                  ])
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.propiedadConsultada
                                          .observaciones_localizacion_in
                                          .length === 0,
                                      expression:
                                        "\n              propiedadConsultada.observaciones_localizacion_in\n                .length === 0\n            "
                                    }
                                  ]
                                },
                                [
                                  _c("td", { attrs: { colspan: "4" } }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("message.sinDatos")) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.procesosConsultados, function(proceso, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            proceso.imagenes !== undefined &&
                            proceso.imagenes !== null &&
                            proceso.imagenes.length > 0
                              ? _c("item-grupo-contenedor", {
                                  attrs: {
                                    imagenes: proceso.imagenes,
                                    errorText: _vm.errorText,
                                    usuarioText: _vm.userText,
                                    copyLinks: _vm.copyLinks,
                                    downloadGroup: _vm.downloadGroup,
                                    title: proceso.grupo
                                  },
                                  on: { verImagen: _vm.verImagen }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.procesosConsultados.length === 0
                ? _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("message.sinDatos")))])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "tab",
            {
              attrs: {
                id: "EST",
                "is-disabled": !_vm.permiteEs,
                name: _vm.$t("message.estimacion")
              }
            },
            [
              _vm.form.modulo === "EST"
                ? _c(
                    "div",
                    _vm._l(_vm.procesosConsultados, function(proceso, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          proceso.imagenes !== undefined &&
                          proceso.imagenes !== null &&
                          proceso.imagenes.length > 0
                            ? _c("item-grupo-contenedor", {
                                attrs: {
                                  imagenes: proceso.imagenes,
                                  errorText: _vm.errorText,
                                  usuarioText: _vm.userText,
                                  copyLinks: _vm.copyLinks,
                                  downloadGroup: _vm.downloadGroup,
                                  title: proceso.grupo
                                },
                                on: { verImagen: _vm.verImagen }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.procesosConsultados.length === 0
                ? _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("message.sinDatos")))])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "tab",
            {
              attrs: {
                id: "REP",
                "is-disabled": !_vm.permiteRep,
                name: _vm.$t("message.reparacion")
              }
            },
            [
              _vm.form.modulo === "REP"
                ? _c(
                    "div",
                    _vm._l(_vm.procesosConsultados, function(item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          item.grupos !== undefined && item.grupos !== null
                            ? _c("item-contenedor", {
                                attrs: { showIfNoImages: false, item: item },
                                on: { verImagen: _vm.verImagen }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.procesosConsultados.length === 0
                ? _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("message.sinDatos")))])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "tab",
            {
              attrs: {
                id: "OUT",
                "is-disabled": !_vm.permiteOut,
                name: _vm.$t("message.salida")
              }
            },
            [
              _vm.propiedadConsultada !== null
                ? _c("div", { staticClass: "table-responsive" }, [
                    _vm.form.modulo === "OUT"
                      ? _c("table", { staticClass: "table--centered" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("message.ventila")))
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("message.temperatura")))
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("message.remarksSalida")))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [
                                _vm.propiedadConsultada.f_ventila_out
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src:
                                          _vm.propiedadConsultada.f_ventila_out,
                                        alt: "f_ventila_out",
                                        width: "250px",
                                        height: "175px"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.verImagen(
                                            {
                                              url:
                                                _vm.propiedadConsultada
                                                  .f_ventila_out
                                            },
                                            _vm.$t("message.ventila")
                                          )
                                        }
                                      }
                                    })
                                  : _c("img", {
                                      attrs: {
                                        width: "250px",
                                        height: "175px",
                                        src: _vm.pathSinImagen,
                                        alt: "f_ventila_out"
                                      }
                                    }),
                                _c("br"),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.propiedadConsultada.kim_ventila)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm.propiedadConsultada.f_temp_out
                                  ? _c("img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: _vm.propiedadConsultada.f_temp_out,
                                        alt: "f_temp_out",
                                        width: "250px",
                                        height: "175px"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.verImagen(
                                            {
                                              url:
                                                _vm.propiedadConsultada
                                                  .f_temp_out
                                            },
                                            _vm.$t("message.temperatura")
                                          )
                                        }
                                      }
                                    })
                                  : _c("img", {
                                      attrs: {
                                        width: "250px",
                                        height: "175px",
                                        src: _vm.pathSinImagen,
                                        alt: "f_temp_out"
                                      }
                                    }),
                                _c("br"),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.propiedadConsultada.monitoring)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("table", [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t("message.locacion")) +
                                            "\n                      "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.observacion")
                                            ) +
                                            "\n                      "
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(
                                        _vm.propiedadConsultada
                                          .observaciones_localizacion,
                                        function(row, index) {
                                          return _c("tr", { key: index }, [
                                            _c("td", [
                                              _vm._v(_vm._s(row.localizacion))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(row.observacion))
                                            ])
                                          ])
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "tr",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.propiedadConsultada
                                                  .observaciones_localizacion
                                                  .length === 0,
                                              expression:
                                                "\n                      propiedadConsultada.observaciones_localizacion\n                        .length === 0\n                    "
                                            }
                                          ]
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "2" } },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t("message.sinDatos")
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.form.modulo === "OUT"
                ? _c(
                    "div",
                    _vm._l(_vm.procesosConsultados, function(item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          item.grupos !== undefined && item.grupos !== null
                            ? _c("item-contenedor", {
                                attrs: { showIfNoImages: false, item: item },
                                on: { verImagen: _vm.verImagen }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.procesosConsultados.length === 0
                ? _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.$t("message.sinDatos")))])
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { scrollable: "", name: "visor", width: "60%", height: "auto" }
        },
        [
          _c("visor-imagen", {
            attrs: { src: _vm.srcImagen, title: _vm.imagenTitle },
            on: { cerrar: _vm.cerrarVisor }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "enviarEir",
            width: "60%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("enviar-eir", {
            attrs: {
              correosCliente:
                _vm.propiedadConsultada != null
                  ? _vm.propiedadConsultada.email_transportista
                  : "",
              secuencia: _vm.secuencia,
              labelEmail: _vm.labelEmail,
              cancelarText: _vm.cancelarText,
              enviarCorreoText: _vm.enviarCorreoText,
              requiredEmailText: _vm.requiredEmailText,
              emailsSent: _vm.emailsSent,
              errorText: _vm.errorText,
              avisoText: _vm.avisoText,
              errorValidationText: _vm.errorValidacionText,
              tipo: "in",
              number:
                _vm.propiedadConsultada !== null
                  ? _vm.propiedadConsultada.number
                  : ""
            },
            on: { enviado: _vm.eirEnviado, cancelar: _vm.cancelarCorreo }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            width: "75%",
            height: "auto",
            scrollable: "",
            name: "editarPropiedades"
          }
        },
        [
          _c("editar-unidad", {
            ref: "editarUnidad",
            attrs: {
              historico: _vm.secuencia == undefined ? false : true,
              numeroContenedor:
                _vm.form.selectedContenedor != null
                  ? _vm.form.selectedContenedor.number
                  : null,
              numeroSecuencia:
                _vm.secuencia == undefined ? "" : _vm.secuencia + "",
              puede_editar_status: _vm.puede_editar_status,
              puede_eliminar:
                _vm.secuencia != undefined ? false : _vm.puede_eliminar,
              puede_editar_gate_in: _vm.puede_editar_gate_in,
              puede_editar_gate_out: _vm.puede_editar_gate_out,
              puede_editar_in: _vm.puede_editar_in,
              puede_editar_out: _vm.puede_editar_out,
              puede_editar_caja: _vm.puede_editar_caja,
              puede_editar_maquina: _vm.puede_editar_maquina,
              puede_enviar_edi_in: _vm.puede_enviar_edi_in,
              puede_enviar_edi_out: _vm.puede_enviar_edi_out
            },
            on: {
              cerrarUnidad: _vm.cerrarUnidad,
              eliminarUnidad: _vm.eliminarUnidad
            },
            model: {
              value: _vm.currentUnidad,
              callback: function($$v) {
                _vm.currentUnidad = $$v
              },
              expression: "currentUnidad"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Amount Machine Yard")]),
        _vm._v(" "),
        _c("th", [_vm._v("Amount Box Yard")]),
        _vm._v(" "),
        _c("th", [_vm._v("Amount Machine")]),
        _vm._v(" "),
        _c("th", [_vm._v("Amount Box")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3447432f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3447432f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/clientes/ConsultaContenedores.vue
// module id = 305
// module chunks = 0